module.exports = "/_next/static/resources/man-1-0833b92c38b1059da6e224954d896fa7.webp";